import React from 'react';
import AssetTeamNavBar from '../../../../layouts/asset-team/AssetTeamNavBar';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import ActiveAndInactiveBody from './ActiveAndInactiveBody';

const AssetTeamActiveAndInactive = () => {
  const { profile } = useUser();
  const { firstName } = profile;

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AssetTeamNavBar currentPage="Active And Inactive" position={firstName} />
        <ActiveAndInactiveBody profile={profile} />
      </main>
    </div>
  );
};

export default AssetTeamActiveAndInactive;
